import * as Actions from "./actions";
import { default as API } from "./services";
import * as Components from "./components";
import * as Containers from "./containers";
import * as Functions from "./functions";
import { default as Constants } from "./constants";
import * as Reducers from "./reducers";
import { default as Sagas } from "./sagas";
import { AuthGate } from "./auth";

export default {
  Actions,
  API,
  Components,
  Constants,
  Containers,
  Functions,
  Reducers,
  Sagas,
  AuthGate,
};
